<template>
    <div class="content page-3">
        <div v-if="$store.state.isProductDataReady">
            <!-- Hidden if there are no products to show -->
            <div v-if="$store.getters.productIds.length">
                <section class="section-order section-white">
                    <h2 class="text-green">Tillegg:</h2>
                    <h4>
                        Velg tillegg per reisende eller velg Fortsett. Du kan også bestille tillegg etter at du har
                        bekreftet
                        reisen:
                    </h4>
                </section>

                <section class="section-order section-white" v-if="$store.getters.extrasPerRoom.length && $store.getters.roomList.length">
                    <h2 class="text-green">
                        Tilvalg per rom:
                    </h2>

                    <div class="person rooms" v-for="(room, i) in $store.getters.roomList" :data-room-uuid="room.id" :data-room-id="room.roomId">
                        <h3>{{ room.name }}</h3>
                        <div class="person-split-row" v-for="product in $store.getters.extrasPerRoom">
                            <div>
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox"
                                               :value="product.ProductID"
                                               :checked="isExtraSelectedOnRoom(room, product)"
                                               @change="roomExtraClick(room, product, $event.target.checked)">
                                        <span></span>
                                        <span>{{ product.ProductUnit.Name }}</span>
                                    </label>
                                </div>
                                <div :class="`activity-${i}-${product.ProductID} toggle`"
                                     v-html="product.raw.Description">
                                </div>
                            </div>
                            <div class="person-split-row-center">
                                <a href="javascript:" @click="toggle(i, product.ProductID)">Les mer</a>
                            </div>
                            <div class="person-split-row-last">
                                + kr {{ displayPriceForRoomExtra(product, room).displayPrice | nok }}

                                <div v-if="!displayPriceForRoomExtra(product, room).isUnitPrice">
                                    <small>pr. person</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="section-order section-white" v-if="$store.getters.extras.length">
                    <h2 class="text-green">Tilvalg per person:</h2>
                    <div class="person" v-for="(person, i) in $store.getters.personList" :key="i">
                        <h3>{{person.firstName}} {{person.lastName}}</h3>

                        <div class="person-split-row" v-for="product in $store.getters.extras" :key="product.ProductID">
                            <div>
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox" :value="product.ProductID"
                                               :checked="hasPersonSelectedExtra(person, product)"
                                               @change="extraClick(person, product, $event.target.checked)">
                                        <span></span>
                                        <span class="description">{{product.raw.Name}}</span>
                                    </label>
                                </div>
                                <div :class="`activity-${i}-${product.ProductID} toggle`"
                                     v-html="product.raw.Description">
                                </div>
                            </div>
                            <div class="person-split-row-center">
                                <a href="javascript:" @click="toggle(i, product.ProductID)">Les mer</a>
                            </div>
                            <div class="person-split-row-last">
                              + kr {{ displayPriceExtra(product).displayPrice | nok }}

                              <div v-if="!displayPriceExtra(product).isUnitPrice">
                                <small>pr. person</small>
                              </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div v-else>
                <section class="section-order section-white">
                    <h2 class="text-green">Ingen tilleggsprodukter tilgjengelig</h2>
                    <p>
                        Det er ingen tillleggsprodukter å vise for denne reisen, du kan gå videre til neste steg.
                    </p>
                </section>
            </div>
        </div>


        <portal to="navButtons">

            <button class="checkout-button button button-fat fat-outline float-left"
                    @click="$router.push({name: 'page2'})">
                Tilbake
            </button>

            <button
                    class="checkout-button button button-fat float-right"
                    @click="$router.push({name: 'page4'})"
            >
                Fortsett
            </button>
        </portal>


        <portal to="overviewButtons">
            <button class="overview-button button button-fat w-100" @click="$router.push({name: 'page4'})">
                Fortsett til neste trinn
            </button>
        </portal>


    </div>
</template>
<script>
import {calculateExtraPrice} from "../calculations";
    export default {
        name: "Page3",
        data() {
            return {
                checked: []
            }
        },
        methods: {
            displayPriceForRoomExtra(product, room) {
                let roomData = this.$store.state.bookingData.roomSelections.find(rs => rs.Room.ProductUnitId == room.roomId);
                return calculateExtraPrice(product, roomData.MinNrOfTravelers);
            },
            displayPriceExtra(product) {
              let persons = this.$store.getters.personList
              return calculateExtraPrice(product, persons.length);
            },
            toggle(id, productId) {
                // TODO(21 jan. 2020) ~ Helge: Refactor
                document.querySelector(`.activity-${id}-${productId}`).classList.toggle('toggle');
            },
            extraClick(person, product, selected) {
                this.$store.commit('updateExtraSelection', {
                    personId: person.id,
                    productId: product.ProductID,
                    selected: selected
                });
            },
            roomExtraClick(room, product, selected) {
                this.$store.commit('updateRoomExtraSelection', {
                    roomId: room.id,
                    productId: product.ProductID,
                    selected: selected
                });
            },
            isExtraSelectedOnRoom(room, product) {
                let selectedRoomExtra = this.$store.state.selectedRoomExtras.find(se => se.roomId === room.id && se.productId === product.ProductID);
                if (selectedRoomExtra == null) return false;

                return selectedRoomExtra.selected;
            },
            hasPersonSelectedExtra(person, product) {
                let selectedExtra = this.$store.state.selectedExtras.find(se => se.personId === person.id && se.productId === product.ProductID);
                if (selectedExtra == null) return false;

                return selectedExtra.selected
            }
        },
        created() {
            this.$store.dispatch('loadProductData')
        }
    };
</script>
